




























import BaseComponent from "@/components/BaseComponent.vue";
import app from "@/app";
import { Component } from "vue-property-decorator";

@Component
export default class PAppUpdate extends BaseComponent {
	updaterData = app.ls.load("updater") || {};
	appName = app.configs.get("OW_APP_NAME");
	appLogo = app.configs.get("OW_APP_LOGO_SRC");
	appAndroidId = app.configs.get("OW_APP_ANDROID_ID");
	oldVersion = app.configs.get("OW_APP_VERSION");

	get newVersion() {
		return this.updaterData.version;
	}
	get forceUpdate() {
		return this.updaterData.forceUpdate;
	}

	updateClick() {
		let webUrl = `https://play.google.com/store/apps/details?id=${
				this.appAndroidId
			}`,
			storeUrl = `market://details?id=${this.appAndroidId}`;
		if (app.isMobileApp()) {
			(window as any).location = storeUrl;
		} else {
			window.open(webUrl, "_blank");
		}
	}
}
